"use strict";

var _possibleConstructorReturn = require("D:\\new_kisan\\kisan_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("D:\\new_kisan\\kisan_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("D:\\new_kisan\\kisan_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var _regeneratorRuntime = require("D:\\new_kisan\\kisan_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _classCallCheck = require("D:\\new_kisan\\kisan_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("D:\\new_kisan\\kisan_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var zlib = require("zlib");

var filter_1 = require("./filter");

var CompressionHandler =
/*#__PURE__*/
function () {
  function CompressionHandler() {
    _classCallCheck(this, CompressionHandler);
  }

  _createClass(CompressionHandler, [{
    key: "writeMessage",

    /**
     * @param message Raw uncompressed message bytes
     * @param compress Indicates whether the message should be compressed
     * @return Framed message, compressed if applicable
     */
    value: function writeMessage(message, compress) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var messageBuffer, output;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                messageBuffer = message;

                if (!compress) {
                  _context.next = 5;
                  break;
                }

                _context.next = 4;
                return this.compressMessage(messageBuffer);

              case 4:
                messageBuffer = _context.sent;

              case 5:
                output = Buffer.allocUnsafe(messageBuffer.length + 5);
                output.writeUInt8(compress ? 1 : 0, 0);
                output.writeUInt32BE(messageBuffer.length, 1);
                messageBuffer.copy(output, 5);
                return _context.abrupt("return", output);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
    /**
     * @param data Framed message, possibly compressed
     * @return Uncompressed message
     */

  }, {
    key: "readMessage",
    value: function readMessage(data) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var compressed, messageBuffer;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                compressed = data.readUInt8(0) === 1;
                messageBuffer = data.slice(5);

                if (!compressed) {
                  _context2.next = 6;
                  break;
                }

                _context2.next = 5;
                return this.decompressMessage(messageBuffer);

              case 5:
                messageBuffer = _context2.sent;

              case 6:
                return _context2.abrupt("return", messageBuffer);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }]);

  return CompressionHandler;
}();

var IdentityHandler =
/*#__PURE__*/
function (_CompressionHandler) {
  _inherits(IdentityHandler, _CompressionHandler);

  function IdentityHandler() {
    _classCallCheck(this, IdentityHandler);

    return _possibleConstructorReturn(this, _getPrototypeOf(IdentityHandler).apply(this, arguments));
  }

  _createClass(IdentityHandler, [{
    key: "compressMessage",
    value: function compressMessage(message) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", message);

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "writeMessage",
    value: function writeMessage(message, compress) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var output;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                output = Buffer.allocUnsafe(message.length + 5);
                /* With "identity" compression, messages should always be marked as
                 * uncompressed */

                output.writeUInt8(0, 0);
                output.writeUInt32BE(message.length, 1);
                message.copy(output, 5);
                return _context4.abrupt("return", output);

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "decompressMessage",
    value: function decompressMessage(message) {
      return Promise.reject(new Error('Received compressed message but "grpc-encoding" header was identity'));
    }
  }]);

  return IdentityHandler;
}(CompressionHandler);

var DeflateHandler =
/*#__PURE__*/
function (_CompressionHandler2) {
  _inherits(DeflateHandler, _CompressionHandler2);

  function DeflateHandler() {
    _classCallCheck(this, DeflateHandler);

    return _possibleConstructorReturn(this, _getPrototypeOf(DeflateHandler).apply(this, arguments));
  }

  _createClass(DeflateHandler, [{
    key: "compressMessage",
    value: function compressMessage(message) {
      return new Promise(function (resolve, reject) {
        zlib.deflate(message, function (err, output) {
          if (err) {
            reject(err);
          } else {
            resolve(output);
          }
        });
      });
    }
  }, {
    key: "decompressMessage",
    value: function decompressMessage(message) {
      return new Promise(function (resolve, reject) {
        zlib.inflate(message, function (err, output) {
          if (err) {
            reject(err);
          } else {
            resolve(output);
          }
        });
      });
    }
  }]);

  return DeflateHandler;
}(CompressionHandler);

var GzipHandler =
/*#__PURE__*/
function (_CompressionHandler3) {
  _inherits(GzipHandler, _CompressionHandler3);

  function GzipHandler() {
    _classCallCheck(this, GzipHandler);

    return _possibleConstructorReturn(this, _getPrototypeOf(GzipHandler).apply(this, arguments));
  }

  _createClass(GzipHandler, [{
    key: "compressMessage",
    value: function compressMessage(message) {
      return new Promise(function (resolve, reject) {
        zlib.gzip(message, function (err, output) {
          if (err) {
            reject(err);
          } else {
            resolve(output);
          }
        });
      });
    }
  }, {
    key: "decompressMessage",
    value: function decompressMessage(message) {
      return new Promise(function (resolve, reject) {
        zlib.unzip(message, function (err, output) {
          if (err) {
            reject(err);
          } else {
            resolve(output);
          }
        });
      });
    }
  }]);

  return GzipHandler;
}(CompressionHandler);

var UnknownHandler =
/*#__PURE__*/
function (_CompressionHandler4) {
  _inherits(UnknownHandler, _CompressionHandler4);

  function UnknownHandler(compressionName) {
    var _this;

    _classCallCheck(this, UnknownHandler);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(UnknownHandler).call(this));
    _this.compressionName = compressionName;
    return _this;
  }

  _createClass(UnknownHandler, [{
    key: "compressMessage",
    value: function compressMessage(message) {
      return Promise.reject(new Error("Received message compressed wth unsupported compression method ".concat(this.compressionName)));
    }
  }, {
    key: "decompressMessage",
    value: function decompressMessage(message) {
      // This should be unreachable
      return Promise.reject(new Error("Compression method not supported: ".concat(this.compressionName)));
    }
  }]);

  return UnknownHandler;
}(CompressionHandler);

function getCompressionHandler(compressionName) {
  switch (compressionName) {
    case 'identity':
      return new IdentityHandler();

    case 'deflate':
      return new DeflateHandler();

    case 'gzip':
      return new GzipHandler();

    default:
      return new UnknownHandler(compressionName);
  }
}

var CompressionFilter =
/*#__PURE__*/
function (_filter_1$BaseFilter) {
  _inherits(CompressionFilter, _filter_1$BaseFilter);

  function CompressionFilter() {
    var _this2;

    _classCallCheck(this, CompressionFilter);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(CompressionFilter).apply(this, arguments));
    _this2.sendCompression = new IdentityHandler();
    _this2.receiveCompression = new IdentityHandler();
    return _this2;
  }

  _createClass(CompressionFilter, [{
    key: "sendMetadata",
    value: function sendMetadata(metadata) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        var headers;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return metadata;

              case 2:
                headers = _context5.sent;
                headers.set('grpc-encoding', 'identity');
                headers.set('grpc-accept-encoding', 'identity,deflate,gzip');
                return _context5.abrupt("return", headers);

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    }
  }, {
    key: "receiveMetadata",
    value: function receiveMetadata(metadata) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6() {
        var headers, receiveEncoding, encoding;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return metadata;

              case 2:
                headers = _context6.sent;
                receiveEncoding = headers.get('grpc-encoding');

                if (receiveEncoding.length > 0) {
                  encoding = receiveEncoding[0];

                  if (typeof encoding === 'string') {
                    this.receiveCompression = getCompressionHandler(encoding);
                  }
                }

                headers.remove('grpc-encoding');
                headers.remove('grpc-accept-encoding');
                return _context6.abrupt("return", headers);

              case 8:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
    }
  }, {
    key: "sendMessage",
    value: function sendMessage(message) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7() {
        var resolvedMessage, compress;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return message;

              case 2:
                resolvedMessage = _context7.sent;
                compress = resolvedMessage.flags === undefined ? false : (resolvedMessage.flags & 2
                /* NoCompress */
                ) === 0;
                _context7.next = 6;
                return this.sendCompression.writeMessage(resolvedMessage.message, compress);

              case 6:
                _context7.t0 = _context7.sent;
                _context7.t1 = resolvedMessage.flags;
                return _context7.abrupt("return", {
                  message: _context7.t0,
                  flags: _context7.t1
                });

              case 9:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
    }
  }, {
    key: "receiveMessage",
    value: function receiveMessage(message) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8() {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.t0 = this.receiveCompression;
                _context8.next = 3;
                return message;

              case 3:
                _context8.t1 = _context8.sent;
                return _context8.abrupt("return", _context8.t0.readMessage.call(_context8.t0, _context8.t1));

              case 5:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));
    }
  }]);

  return CompressionFilter;
}(filter_1.BaseFilter);

exports.CompressionFilter = CompressionFilter;

var CompressionFilterFactory =
/*#__PURE__*/
function () {
  function CompressionFilterFactory(channel) {
    _classCallCheck(this, CompressionFilterFactory);

    this.channel = channel;
  }

  _createClass(CompressionFilterFactory, [{
    key: "createFilter",
    value: function createFilter(callStream) {
      return new CompressionFilter();
    }
  }]);

  return CompressionFilterFactory;
}();

exports.CompressionFilterFactory = CompressionFilterFactory;